import { useEffect } from 'react';
import { cLog } from '../utils/consoleLog';
import ga, { init } from '../utils/gaConnect';

export default function useGoogleAnalytics() {
  useEffect(() => {
    init();
  }, []);

  return ga;
}

export const usePageViewToGASender = () => {
  useEffect(() => {
    cLog('usePageViewToGASender');
    // ga.pageview(window.location.pathname);
    ga.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);
};
